module.exports = __webpack_public_path__ + "4715a3911f6c58719e121b81317c8e89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_icon_2x.png
// module id = 100
// module chunks = 0 1 2 3 4